
import { Component, Prop, Vue } from 'vue-property-decorator'
import ScriptLoader from '@/utils/ScriptLoader'
import { NavigationGuardNext, Route } from 'vue-router'
import PolicyInformationTile from '@/componentsTenant/PolicyInformationTile.vue'
import TeaserListPolicies from '@/componentsTenant/TeaserListPolicies.vue'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'

@Component({
  components: {
    PolicyInformationTile,
    TeaserListPolicies
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.ACCOUNT_MANAGEMENT).catch((_reason) =>
        Promise.resolve()
      ),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POLICIES).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.PARTNER_PROXY).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.MOTOR).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.SHUR).catch((_reason) => Promise.resolve()),
      window.ENV_CONFIG.WEB_COMPONENTS.LIFE
        ? ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.LIFE).catch((_reason) => Promise.resolve())
        : Promise.resolve()
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.ACCOUNT_MANAGEMENT).catch((_reason) =>
        Promise.resolve()
      ),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POLICIES).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.PARTNER_PROXY).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.MOTOR).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.SHUR).catch((_reason) => Promise.resolve()),
      window.ENV_CONFIG.WEB_COMPONENTS.LIFE
        ? ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.LIFE).catch((_reason) => Promise.resolve())
        : Promise.resolve()
    ])
      .then(() => next())
      .catch((_reason) => next())
  }
})
export default class PoliciesPage extends Vue {
  private assetsBaseUrl: string = window.ENV_CONFIG.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''

  private partnerProxyId: string | null = null

  @Prop({ default: false, type: Boolean })
  private showModificationDate!: boolean

  public created(): void {
    this.partnerProxyId = getPartnerProxyId()
  }

  private isTrue(value: string | boolean) {
    return !!value && value.toString().toLowerCase() === 'true'
  }

  public showQuotes(): boolean {
    return this.isTrue(window.ENV_CONFIG.FEATURE_FLAGS.SHOW_QUOTES)
  }
}
